import { useEffect, useRef, useState } from 'react';

import DonateFooter from './npo/details/DonateFooter';

interface DonationFooterWebProps {
  npoId: string;
  npoName: string;
}

const DonationFooterWeb = ({ npoId, npoName }: DonationFooterWebProps) => {
  const [isSticky, setIsSticky] = useState<boolean>(true);
  const stickyRef = useRef<HTMLDivElement>(null);

  const observer = new IntersectionObserver(
    ([entry]) => {
      setIsSticky(entry.intersectionRatio < 1);
    },
    { threshold: [1] }
  );

  useEffect(() => {
    const stickyConst = stickyRef.current;

    if (stickyRef.current) observer.observe(stickyRef.current);
    return () => {
      if (stickyConst) observer.unobserve(stickyConst);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={stickyRef} style={{ bottom: -1 }} className="sticky pb-6">
      <div
        className={['transition-all', isSticky ? 'sm:mx-12 md:mx-24 rounded-3xl overflow-hidden shadow-lg' : ''].join(
          ' '
        )}>
        <DonateFooter npoId={npoId} npoName={npoName} />
      </div>
    </div>
  );
};

export default DonationFooterWeb;
